module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("This book is dedicated to my very dear and much admired Mr Witherspoon, my fourth grade teacher at Geelong Road State School, who not only believed I could read but gave me the key to the book cabinet, beginning my lifelong affair with literature. I have never had a better present. And at last I get a chance to say thank you.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("With thanks to Catherine Howat’s kind expertise on ships, Jean Greenwood’s recall of music, Maggie Walsh’s Maori wisdom, David Greagg’s navigation, Dennis, Mark and Ben Pryor.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("And in very loving memory of my cousin Muriel Wright, who died before she could read this. I hope she would have liked it. Missed much more than she would have believed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae521fd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Dedication.vue
// module id = 69
// module chunks = 0